import one from '../assets/png/project1.png'
import two from '../assets/png/project2.png'
import three from '../assets/png/project3.png'



export const projectsData = [
    {
        id: 1,
        projectName: 'Lab Results Viewer Application',
        projectDesc: 'A mobile application to enhance accessibility and convenience of medical lab results for patients',
        tags: ['Dart', 'Flutter', 'Kotlin', 'Jetpack Compose', 'NestJS'],
        code: 'https://www.github.com/Welu2/lab_result_viewer_Flutter',
        demo: '',
        image: one
    },
    {
        id: 2,
        projectName: 'Plant Disease Detection & Classification',
        projectDesc: 'An object detection model for plant disease identification using YOLOv8 and a multi-class agricultural image dataset (29 disease categories).',
        tags: ['Python','YOLOv8', 'Google Colab', 'Ultralytics'],
        code: 'https://colab.research.google.com/drive/1_N3QFujBcuTH644Mk3EqxbfX8R2GNJOy?usp=sharing',
        demo: '',
        image: two
    },
    {
        id: 3,
        projectName: 'ROS 2 Autonomous Robot for Precision Agriculture',
        projectDesc: 'A full-stack autonomous mobile robot designed to navigate agricultural environments and perform real-time crop health monitoring.',
        tags: ['Python', 'C++', 'ROS 2', 'OpenCV', 'Gazebo'],
        code: 'https://github.com/semegn19/Agribot_ws/',
        demo: '',
        image: three
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/